import React from 'react';
import { motion } from 'framer-motion';
import { Info, ExternalLink } from 'lucide-react';
const listItemVariants = {
  hidden: {
    opacity: 0,
    x: -8
  },
  visible: (i: number) => ({
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.4,
      delay: 0.5 + i * 0.1,
      ease: 'easeOut'
    }
  })
};
export function ResellerInfo() {
  return <motion.section initial={{
    opacity: 0,
    y: 16
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6,
    delay: 0.3,
    ease: 'easeOut'
  }} className="w-full" aria-labelledby="info-heading" data-id="element-71">
      <div className="flex items-center gap-2.5 mb-5" data-id="element-72">
        <Info className="h-5 w-5 text-slate-400" aria-hidden="true" data-id="element-73" />
        <h2 id="info-heading" className="text-xl sm:text-2xl font-semibold text-slate-900" data-id="element-74">
          What does this mean?
        </h2>
      </div>

      <ul className="space-y-4 mb-8" role="list" data-id="element-75">
        <motion.li custom={0} initial="hidden" animate="visible" variants={listItemVariants} className="flex items-start gap-3" data-id="element-76">
          <span className="mt-2 block h-1.5 w-1.5 rounded-full bg-slate-300 flex-shrink-0" aria-hidden="true" data-id="element-77" />
          <span className="text-slate-600 leading-relaxed" data-id="element-78">
            The website you were trying to visit was hosted through{' '}
            <span className="font-medium text-slate-800" data-id="element-79">CloudZyro</span>
          </span>
        </motion.li>
        <motion.li custom={1} initial="hidden" animate="visible" variants={listItemVariants} className="flex items-start gap-3" data-id="element-80">
          <span className="mt-2 block h-1.5 w-1.5 rounded-full bg-slate-300 flex-shrink-0" aria-hidden="true" data-id="element-81" />
          <span className="text-slate-600 leading-relaxed" data-id="element-82">
            CloudZyro's hosting services have been temporarily suspended
          </span>
        </motion.li>
        <motion.li custom={2} initial="hidden" animate="visible" variants={listItemVariants} className="flex items-start gap-3" data-id="element-83">
          <span className="mt-2 block h-1.5 w-1.5 rounded-full bg-slate-300 flex-shrink-0" aria-hidden="true" data-id="element-84" />
          <span className="text-slate-600 leading-relaxed" data-id="element-85">
            If you are a customer of CloudZyro, we recommend contacting them
            directly for information about your services
          </span>
        </motion.li>
      </ul>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.4,
      delay: 0.9
    }} data-id="element-86">
        <a href="#" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg border border-slate-300 text-sm font-medium text-slate-700 bg-white hover:bg-slate-50 hover:border-slate-400 hover:text-g7-navy transition-all" data-id="element-87">
          Contact CloudZyro
          <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" data-id="element-88" />
        </a>
      </motion.div>
    </motion.section>;
}